export default __webpack_public_path__ + "static/media/banner.fb73dabb.jpg";